import React from "react";

import "../../scss/atoms/_progress.scss";

class Progress extends React.Component {
  render() {
    return (
      <>
        <p className="progress-title">{this.props.title}</p>
        <div className="progress">
          <span className="progress-indicator"></span>
          <span className="progress-indicator"></span>
          <span className="progress-indicator"></span>
          <span className="progress-indicator"></span>
          <span className="progress-indicator"></span>
          <span className="progress-indicator"></span>
          <span className="progress-indicator"></span>
          <span className="progress-indicator"></span>
          <span className="progress-indicator"></span>
          <span
            className="progress-completion"
            style={{ width: (this.props.value / this.props.scale) * 100 + "%" }}
          ></span>
        </div>
      </>
    );
  }
}

export default Progress;
